import { render, staticRenderFns } from "./AlertCard.vue?vue&type=template&id=6b75796d&scoped=true&"
import script from "./AlertCard.vue?vue&type=script&lang=ts&"
export * from "./AlertCard.vue?vue&type=script&lang=ts&"
import style0 from "./AlertCard.vue?vue&type=style&index=0&id=6b75796d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b75796d",
  null
  
)

export default component.exports